import { render, staticRenderFns } from "./VaccinationPhase.vue?vue&type=template&id=0bc5f8dc&scoped=true&"
import script from "./VaccinationPhase.vue?vue&type=script&lang=js&"
export * from "./VaccinationPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc5f8dc",
  null
  
)

export default component.exports